import React, { useEffect, useRef, useState } from 'react';
import Image from '../assets/img/estatecontact.jpg';
import { IoIosArrowDown } from "react-icons/io";
import { Link, animateScroll as scroll } from 'react-scroll';
import '../styles/Contact.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { motion, useScroll, useTransform } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const Contact = () => {
  const sBellowRef1 = useRef(null);
  const sBellowRef2 = useRef(null);
  const formInputsRef = useRef(null);
  const gitRef = useRef(null);
  const contactDetailsRef = useRef(null);
  const secndSection = useRef(null);
  const s3C = useRef(null);
  const cntct1 = useRef(null);
  const cntct2 = useRef(null);
  const cntct3 = useRef(null);
  const arrowBtnRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [animatedOnce, setAnimatedOnce] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);
  
  const scrollToSection = () => {
    scroll.scrollTo(secndSection.current.offsetTop, {
      smooth: true,
      duration: 1000,
    });
  };

  const imageRef = useRef(null); 
  //! ------------------------------------->> 1ST SECTION ANIMATION
  useEffect(() => {
    // Animations for initial content
    gsap.from(sBellowRef1.current, {
      y: 50,
      opacity: 0,
      duration: 1,
    });

    gsap.from(sBellowRef2.current, {
      y: 50,
      opacity: 0,
      duration: 1,
      delay: 0.2,
    });

    const animation = gsap.to(sBellowRef1.current, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power3.out',
      paused: true,
    });

    const animation2 = gsap.to(sBellowRef2.current, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power3.out',
      paused: true,
    });

    setTimeout(() => {
      animation.play();
    }, 300);
    setTimeout(() => {
      animation2.play();
    }, 600);

    // Animație pentru border SVG
    if (arrowBtnRef.current) {
      const circle = arrowBtnRef.current.querySelector('circle');
      const length = circle.getTotalLength();

      circle.style.strokeDasharray = length;
      circle.style.strokeDashoffset = length;

      gsap.to(circle, {
        strokeDashoffset: 0,
        duration: 1,
        delay: 1,
        ease: 'power2.inOut',
      });
    }

    ScrollTrigger.create({
      trigger: sBellowRef2.current,
      start: 'top 80%',
      onEnter: () => {
        setIsVisible(true);
      },
    });
  }, []);

  useEffect(() => {
    if (isVisible && !animatedOnce) {
      // Animations for other elements
      gsap.from(formInputsRef.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: formInputsRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      gsap.from(gitRef.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: gitRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      gsap.from(contactDetailsRef.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: contactDetailsRef.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      gsap.from(s3C.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: s3C.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      gsap.from(cntct1.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: cntct1.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      gsap.from(cntct2.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: cntct2.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      gsap.from(cntct3.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        scrollTrigger: {
          trigger: cntct3.current,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      });

      const lines = document.querySelectorAll('.line-s .line-text');
      lines.forEach((line, idx) => {
        gsap.from(line, {
          opacity: 0,
          y: 50,
          duration: 0.5,
          delay: idx * 0.2,
          scrollTrigger: {
            trigger: gitRef.current,
            start: 'top 30%',
            toggleActions: 'play none none none',
          },
        });
      });

      setAnimatedOnce(true);
    }
  }, [isVisible, animatedOnce]);

  const addToRefs = (el, refArray) => {
    if (el && !refArray.current.includes(el)) {
      refArray.current.push(el);
    }
  };

  //! ------------------------------------->> 2ND TEXT ANIMATION
  const textLinesRefs = useRef([]);

  const splitTextIntoLines = (text) => {
    const words = text.split(' ');
    const lines = [];
    let currentLine = [];

    words.forEach(word => {
      const testLine = [...currentLine, word].join(' ');
      if (testLine.length < 40) {
        currentLine.push(word);
      } else {
        lines.push(currentLine.join(' '));
        currentLine = [word];
      }
    });

    if (currentLine.length > 0) {
      lines.push(currentLine.join(' '));
    }

    return lines;
  };

  const serviceSectionsRefs = useRef([]);

  useEffect(() => {
    if (isVisible) {
      const tl = gsap.timeline();

      serviceSectionsRefs.current.forEach((section, index) => {
        const lines = textLinesRefs.current.slice(index * 3, index * 3 + 3);
        lines.forEach(line => {
          const textLines = line.querySelectorAll('div');
          tl.fromTo(
            textLines,
            {
              y: 35,
              opacity: 0
            },
            {
              y: 0,
              opacity: 1,
              duration: 0.7,
              ease: 'power4.out',
              stagger: { amount: 0.5 }
            }
          );
        });
      });

      tl.play();
      textLinesRefs.current.forEach((line) => {
        line.classList.remove('hidden');
      });
    }
  }, [isVisible]);

  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ["-40%", "80%"]); 

  const handleMouseEnter = () => {
    if (arrowBtnRef.current) {
      const circle = arrowBtnRef.current.querySelector('circle');
      circle.setAttribute('stroke', 'rgba(39, 68, 236, 0.767)');
    }
  };

  const handleMouseLeave = () => {
    if (arrowBtnRef.current) {
      const circle = arrowBtnRef.current.querySelector('circle');
      circle.setAttribute('stroke', 'rgba(39, 68, 236, 0.767)');
    }
  };

  return (
  <div className='overflow-x-hidden'>
    <section className='Contact h-screen mb-2 bg-cover bg-center relative rounded-b-[1.5rem] overflow-hidden'>
    <div className='absolute top-0 left-0 w-full h-screen overflow-hidden rounded-b-[1.5rem] z-10'> 
        <motion.div 
          className='w-full h-full rounded-b-[1.5rem]'          
          style={{ y }}
        >
          <img className='w-full h-full object-cover banr_img rounded-b-[1.5rem]' src={Image} alt="House Banner" ref={imageRef}/>
        </motion.div>
      </div>
      <div className="absolute w-full h-full bg-cover bg-center rounded-b-[4rem]" ></div>
     
      <div className="relative z-20">
        <Header />

        <div className='scroll.bellow flex flex-col justify-center items-center mt-20' ref={sBellowRef1}>
          <h1 className='top-heading text-white leading-[2.5rem] text-[3.5rem] font-normal tracking-tight mt-20'>Contact us</h1>
          <Link
            to='contact-details' //! Scroll reference
            smooth={true}
            duration={1000}
          >
            <button 
              ref={arrowBtnRef}
              className='arrow-btn flex items-center justify-center mt-6 rounded-full w-20 h-20 hover:bg-indigo-700 hover:transform hover:scale-105 duration-500'
              onClick={scrollToSection}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <svg className="w-30 h-30 md:text-white" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" stroke="rgba(39, 68, 236, 0.767)" strokeWidth="1" fill="transparent" />
              </svg>
              <IoIosArrowDown className='arrow w-10 h-10 absolute md:text-white' />
            </button>
          </Link>
        </div>
        <div className='flex flex-col justify-end text-white mt-12 ml-16' ref={sBellowRef2}>
          <div className="mb-4">
            <strong>ADDRESS:</strong>
            <p>OAKS LANE SA</p>
            <p>Chemin Rieu 10, 1208 Geneva</p>
          </div>
          <div className="mb-4">
            <strong>PHONE:</strong>
            <p>+41 22 700 16 88</p>
          </div>
          <div>
            <strong>EMAIL:</strong>
            <p>contact@EstateLand.it</p>
          </div>
        </div>
      </div>
    </section>
      {/* SECTION 2 */}
    <section id='contact-form' className='md:h-screen lg:h-auto min-h-[350px] contact-form-reverse' ref={secndSection}>
      <div className='flex flex-col gap-y-4 py-6 px-6 md:flex-row mobile-reverse mt-10'>
        <div className='inputs-form h-auto w-full md:w-9/12 mt-8 md:ml-4 mx-auto' ref={formInputsRef}>
          <form className='flex flex-col gap-y-4'>
            <div className='flex flex-col md:flex-row gap-x-2'>
              <input
                className="border-b border-gray-300 focus:border-indigo-700 outline-none bg-transparent w-full px-4 h-14 text-sm text-gray-500"
                type="text"
                placeholder="First Name*"
              />
              <input
                className="border-b border-gray-300 focus:border-indigo-700 outline-none bg-transparent w-full px-4 h-14 text-sm text-gray-500"
                type="text"
                placeholder="Last Name*"
              />
            </div>
            <div className='flex flex-col md:flex-row gap-x-2'>
              <input
                className="border-b border-gray-300 focus:border-indigo-700 outline-none bg-transparent w-full px-4 h-14 text-sm text-gray-500"
                type="text"
                placeholder="Email*"
              />
              <input
                className="border-b border-gray-300 focus:border-indigo-700 outline-none bg-transparent w-full px-4 h-14 text-sm text-gray-500"
                type="text"
                placeholder="Phone*"
              />
            </div>
            <textarea
              className="border-b border-gray-300 focus:border-indigo-700 outline-none bg-transparent resize-none w-full p-2 h-36 text-sm text-gray-500"
              placeholder="Message*"
              defaultValue="Hi, I'm interested in this property and I want to schedule a visit."
            />
              <button className="send-btn relative border border-indigo-700 bg-transparent px-6 py-[0.4rem] font-medium text-white 
                rounded-full backdrop-blur-xl overflow-hidden group transition duration-500">
                <p className="relative z-10">Send Message</p>
                <span className="absolute inset-0 bg-indigo-700 transition-transform duration-500 transform group-hover:-translate-x-full"></span>
              </button>
          </form>
        </div>

        <div id='GIT' className='w-full md:w-1/3 md:ml-20 ml-2 md:px-2 px-0 -mt-[1.5rem]' ref={gitRef}>
          {/* Descrierea pentru programări */}
          <div className='mb-6 md:mt-12 mt-0 md:leading-[1] leading-[0.9]'>
            <h1 className='text-white text-[2.5rem]'>
              BOOK FORM
            </h1>
          </div>
          <div className='md:leading-[1] leading-[0.9] mt-16'>
            <h3 className='text-white text-[2rem] heading-bs line-clamp-3'>
              Please contact us & make your appointment.
            </h3>        
          </div>

        <div className="line-c hidden text-neutral-400 mt-24 md:leading-[1.1] leading-[1.1]" ref={(el) => addToRefs(el, textLinesRefs)}>
            {splitTextIntoLines("Please do not hesitate to contact us directly. Alternatively, you can send us a message by filling out the form.").map((line, idx) => (
              <p key={idx} className="w-9/12 xl:w-[600px] lg:w-[600px] md:w-[600px] line-text">{line}</p>
            ))}
          </div>
        </div>
      </div>
  </section>
  
  <Footer />
  </div>
  );
}

export default Contact;